export default "__VITE_ASSET__CNYlBzVS__"